import { createAction } from '@reduxjs/toolkit';

export const saveConfirmationShownChange = createAction('[SaveBtn] saveConfirmationShownChange');

export const clickedChange = createAction('[SaveBtn] clickedChange');
